import React, { useEffect, useState } from 'react'
import Modal from './Modal'
import { editCar } from '../../functions/stateList'
import CarModalInput from '../inputs/CarModalInput'
import { carEditSubmit } from '../../functions/CarModalSubmit'
import CarModalSelect from '../inputs/CarModalSelect'
import ModalSubmitFormButton from '../buttons/ModalSubmitFormButton'
import PlateInput from '../inputs/PlateInput'

function CarInfoModal({ car_models, car, setShowModal, setCar }) {
  const [inputs, setInputs] = useState({
    ...editCar,
  })

  const [error, setError] = useState({
    ...editCar,
  })
  const [isSubmit, setIsSubmit] = useState(false)

  useEffect(() => {
    async function fetchData() {
      setInputs({
        car_model: car?.['car_model_id'],
        color: car?.color,
        monthly_ride: car?.monthly_ride,
        description: car?.description,
        first: car?.plate_number?.first,
        letter: car?.plate_number?.letter,
        second: car?.plate_number?.second,
        state: car?.plate_number?.state,
        aras_plate: car?.aras_plate,
      })
      setError({
        ...editCar,
      })
    }

    fetchData()
  }, [])

  const inputHandler = (e) => {
    let name = e.target.name
    let value = e.target.value

    setInputs({
      ...inputs,
      [name]: value,
    })
    setError({
      ...error,
      [name]: '',
    })
  }

  const formHandler = async (e) => {
    e.preventDefault()

    await carEditSubmit(setIsSubmit, inputs, setShowModal, setCar, setError, car, error)
  }

  return (
    <Modal>
      <form onSubmit={formHandler}>
        {/*header*/}
        <div className="p-3 md:p-5">
          <h3 className="text-xl md:text-3xl font-semibold text-center dark:text-slate-200">
            اطلاعات خودرو
          </h3>
        </div>

        {/*body*/}
        <div className="relative p-6 flex flex-col">
          <CarModalSelect
            title={'نوع خودرو'}
            isSubmit={isSubmit}
            name={'car_model'}
            value={inputs?.car_model}
            inputHandler={inputHandler}
            error={error}
            list={car_models}
            text_key={'model'}
          />

          <CarModalInput
            title={'رنگ خودرو'}
            type={'text'}
            isSubmit={isSubmit}
            name={'color'}
            value={inputs?.color}
            inputHandler={inputHandler}
            error={error}
          />

          <CarModalInput
            maxLength={9}
            title={'میانگین کیلومتر در ماه'}
            type={'number'}
            isSubmit={isSubmit}
            name={'monthly_ride'}
            value={inputs?.monthly_ride}
            inputHandler={inputHandler}
            error={error}
          />

          <PlateInput
            isSubmit={isSubmit}
            inputHandler={inputHandler}
            error={error}
            inputs={inputs}
            setInputs={setInputs}
          />
        </div>

        {/*footer*/}
        <ModalSubmitFormButton
          setShowModal={setShowModal}
          allowToEnter={
            (inputs?.aras_plate?.length === 5 ||
              inputs?.aras_plate?.length === 7 ||
              inputs?.first?.length > 0 ||
              inputs?.second?.length > 0 ||
              inputs?.state?.length > 0) &&
            true
          }
          isSubmit={isSubmit}
        />
      </form>
    </Modal>
  )
}

export default React.memo(CarInfoModal)
